module.exports = __webpack_public_path__ + "static/media/news_4.fabcb83a.png";